import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const AccountPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./AccountPage')).AccountPage,
  }))
);

export const AgentProfilePage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./AgentProfilePage')).AgentProfilePage,
  }))
);
